import { initComponent } from './core/init-component.js'

initComponent('.js-pdp-grid-container', section => {

  const panel = section.querySelector('.js-product-details-panel');
  let ticking = false;

  const syncPanelScroll = () => {
    if (window.innerWidth < 1024) {
      panel.scrollTop = 0;
      return;
    }

    const containerRect = section.getBoundingClientRect();
    // Total page distance the user can scroll while the container occupies the viewport
    const containerScrollableHeight = containerRect.height - window.innerHeight;

    if (containerScrollableHeight <= 0) return;

    // How many px of the container have passed above the viewport top
    const scrolled = -containerRect.top;
    const progress = Math.max(0, Math.min(1, scrolled / containerScrollableHeight));

    const panelScrollableHeight = panel.scrollHeight - panel.clientHeight;
    panel.scrollTop = progress * panelScrollableHeight;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        syncPanelScroll();
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  return {
    unload() {
      window.removeEventListener('scroll', onScroll);
    }
  }
})
